import { connect } from 'react-redux';

import SplitterComponent from './SplitterComponent';

import * as commonSelectors from '../Shared/selectors';

const mapStateToProps = (state) => {
  const isMobileScreen = commonSelectors.getIsMobileScreen(state);
  return {
    isMobileScreen,
  };
};

export default connect(mapStateToProps, null)(SplitterComponent);
